export default __webpack_public_path__ + "static/media/ukrasi.f9cb3a27.jpg";